export default "__VITE_ASSET__8psLw$Mh__"